var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9612 1.85942C13.3577 0.620884 11.6193 -0.392462 9.59708 0.197531C8.63078 0.476646 7.78771 1.07522 7.20559 1.89545C6.62347 1.07522 5.78039 0.476646 4.81409 0.197531C2.7874 -0.383454 1.05345 0.620884 0.449949 1.85942C-0.396758 3.59337 -0.0454645 5.54349 1.49482 7.65576C2.70183 9.30864 4.42677 10.984 6.93086 12.9297C7.01 12.9914 7.10748 13.0249 7.20784 13.0249C7.3082 13.0249 7.40569 12.9914 7.48482 12.9297C9.98441 10.9885 11.7139 9.32665 12.9209 7.65576C14.4566 5.54349 14.8079 3.59337 13.9612 1.85942Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.c030d1420334c9e04cca20a917fc8d4e.svg";
export { ForwardRef as ReactComponent };